import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
import { AuthGuard } from './service/guards/auth.guard';
import { ClientGuard } from './service/guards/client.guard';
import { InternalGuard } from './service/guards/internal.guard';
import { ParamsGuard } from './service/guards/params.guard';
import { FullLayoutComponent } from './layouts/full-layout.component';
import { ClientCreationComponent } from './client-creation/client-creation.component';
import { BugNotificationsOverviewComponent } from './notifications/bug-notifications-overview/bug-notifications-overview.component';
import { PatComponent } from './api/pat/pat.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/clients',
    pathMatch: 'full',
  },
  {
    path: 'c/:client',
    canActivate: [ClientGuard],
    children: [
      {
        path: '',
        component: FullLayoutComponent,
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
          {
            path: 'dashboard',
            loadChildren: () => import('./dashboard/dashboard.routing').then(m => m.DASHBOARD_ROUTES),
          },
          {
            path: 'ap',
            loadChildren: () => import('./ap/ap.routing').then(m => m.AP_ROUTES),
          },
          {
            path: 'ar',
            loadChildren: () => import('./ar/ar.routing').then(m => m.AR_ROUTES),
          },
          {
            path: 'gl',
            loadChildren: () => import('./gl/gl.routing').then(m => m.GL_ROUTES),
          },
          {
            path: 'vat',
            loadChildren: () => import('./vat/vat.routing').then(m => m.VAT_ROUTES),
          },
          {
            path: 'accounting',
            loadChildren: () => import('./accounting/accounting.routing').then(m => m.ACCOUNTING_ROUTES),
          },
          {
            path: 'settings',
            loadChildren: () => import('./client-settings/client-settings.routing').then(m => m.CLIENT_SETTINGS_ROUTES),
          },
          {
            path: 'service',
            loadChildren: () => import('./intercom/intercom.routing').then(m => m.INTERCOM_ROUTES),
          },
          {
            path: 'api',
            loadChildren: () => import('./api/api.routing').then(m => m.API_ROUTES),
          },
          {
            path: 'banking',
            loadChildren: () => import('./banking/banking.routing').then(m => m.BANKING_ROUTES),
          },
          {
            path: 'pat',
            component: PatComponent,
            data: {
              title: 'PAT.TITLE',
            },
          },
        ],
      },
      {
        path: 'file',
        loadChildren: () => import('./iframe-file/iframe-file.routing').then(m => m.IFRAME_FILE_ROUTES),
      },
    ],
  },
  {
    path: 'register',
    canActivateChild: [ParamsGuard],
    loadChildren: () => import('./registration/registration.routing').then(m => m.REGISTRATION_ROUTES),
  },
  {
    path: 'auth',
    canActivateChild: [ParamsGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./auth/auth.routing').then(m => m.AUTH_ROUTES),
      },
    ],
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    canActivateChild: [ParamsGuard],
    component: FullLayoutComponent,
    loadChildren: () => import('./settings/settings.routing').then(m => m.SETTINGS_ROUTES),
  },
  {
    path: 'web-ci',
    canActivateChild: [ParamsGuard],
    loadChildren: () => import('./web-ci/web-ci.routing').then(m => m.WEB_CI_ROUTES),
  },
  {
    path: 'messages',
    canActivate: [AuthGuard],
    component: FullLayoutComponent,
    loadChildren: () => import('./messages/messages.routing').then(m => m.MESSAGES_ROUTES),
  },
  {
    path: 'lobby',
    canActivate: [InternalGuard],
    loadChildren: () => import('./lobby/lobby.routing').then(m => m.LOBBY_ROUTES),
  },
  {
    path: 'qualibox',
    canActivate: [AuthGuard],
    loadChildren: () => import('./qualibox/qualibox.routing').then(m => m.QUALIBOX_ROUTES),
  },
  {
    path: 'oldcreate',
    canActivateChild: [ParamsGuard],
    loadChildren: () => import('./old-client-creation/client-creation.routing').then(m => m.CLIENT_CREATION_ROUTES),
  },
  {
    path: 'create/client',
    canActivate: [AuthGuard],
    canActivateChild: [ParamsGuard],
    component: ClientCreationComponent,
    data: {
      title: 'AUTH.CLIENTS.CREATE.TITLE',
    },
  },
  {
    path: 'notifications',
    canActivate: [AuthGuard],
    canActivateChild: [ParamsGuard],
    component: FullLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'bugs',
        pathMatch: 'full',
      },
      {
        path: 'bugs',
        component: BugNotificationsOverviewComponent,
        data: {
          title: 'NOTIFICATIONS.OVERVIEW.BUGS.TITLE',
        },
      },
    ],
  },
  {
    path: '**',
    canActivateChild: [ParamsGuard],
    redirectTo: 'auth/clients',
  },
];

@NgModule({
})
export class AppRoutingModule {
}
